<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <div class="title is-6 is-marginless">
          Προσθήκη Λόγου Διαγραφής Παραγγελίας
        </div>
      </div>
      <div class="card-header-icon">
        <div class="field">
          <div class="control">
            <router-link
              :to="{ name: 'settings.cancelOrderReasons.list' }"
              class="button"
            >
              <span class="icon is-small"><i class="fa fa-list"/></span
              ><span>Λίστα</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <form @submit.prevent="submit">
      <div class="card-content">
        <div class="field">
          <label class="label">Τίτλος *</label>
          <div class="control">
            <textarea-autosize
              v-validate="'required'"
              v-model.trim="newCancelOrderReason.title"
              class="textarea"
              name="title"
              rows="1"
            />
          </div>
          <div v-show="errors.has('title')" class="help is-danger">
            Εισάγετε τίτλο
          </div>
        </div>
      </div>
      <div class="card-footer">
        <FormSubmit :is-saving="isSaving" @reset="reset" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EditItem from '@/views/components/EditItem';

export default {
  extends: EditItem,
  data() {
    return {
      newCancelOrderReason: {
        title: '',
      },
    };
  },
  methods: {
    ...mapActions({
      addCancelOrderReason: 'cancelOrderReasons/add/addCancelOrderReason',
    }),
    async submit() {
      try {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          throw Error('Client-side validation failed');
        }

        this.isSaving = true;
        await this.addCancelOrderReason({
          cancelOrderReason: this.newCancelOrderReason,
        });
        this.isSaving = false;

        this.$router.push({ name: 'settings.cancelOrderReasons.list' });
        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Η κατηγορία αποθηκεύτηκε',
        });
      } catch (err) {
        this.isSaving = false;
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
    reset() {
      this.newCancelOrderReason = {
        title: '',
      };

      this.$validator.reset();
    },
  },
};
</script>
